import React from 'react';
import './services.css';
import portfolioConfig from '../../config/portfolioConfig';

const Services = () => {
  const { services } = portfolioConfig;

  return (
    <section id="services" className="services-section section">
      <div className="container services-section__container">
        <div className="services-section__intro">
          <div>
            <p className="section-eyebrow">Services</p>
            <h2>What I can help ship when the product needs both build speed and taste.</h2>
          </div>
          <p className="section-copy">
            This section is now much closer to how real client work gets discussed: scope,
            direction, and delivery focus instead of icon-heavy filler cards.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <article key={service.title} className="services-card panel">
              <h3>{service.title}</h3>
              <p className="services-card__summary">{service.summary}</p>
              <ul className="services-card__list">
                {service.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
